import {
    React,
    useState,
    useCallback,
    useEffect,
    useRef,
} from 'react';
import Grid from '../components/grid/Grid';
import Keyboard from '../components/keyboard/Keyboard';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer'
import Option from '../components/option/Option';
import Message from '../components/message/Message';
import config from '../configs/AppConfig';
import wordlist from '../configs/WordList';
import FINDING_WORD from '../utils/WordUtil';
import storage from '../utils/StorageUtil';
import './Wordle.css';

console.log('FINDING_WORD: ', FINDING_WORD);

function Wordle() {
    const [loading, setLoading] = useState(true);
    const [gameOver, setGameOver] = useState(false);
    const [letters, setLetters] = useState([]);
    const [word, setWord] = useState('');
    const [status, setStatus] = useState(null);
    const [displayOption, setDisplayOption] = useState(false);
    const [option, setOption] = useState('help');
    const [showMessage, setShowMessage] = useState(false);
    const [message, setMessage] = useState('');
    const [keyboardLetters, setKeyboardLetters] = useState({
        correct: [],
        misplaced: [],
        wrong: [],
    });

    useEffect(() => {
        if (storage.getUser() === null) {
            // create a new user
            const textStatistics = {
                played: 0,
                win: 0,
                currentStreak: 0,
                maxStreak: 0,
            };

            const graphStatistics = {
                one: 0,
                two: 0,
                three: 0,
                four: 0,
                five: 0,
                six: 0,
            };

            const newUser = {
                textStatistics,
                graphStatistics,
            };

            storage.saveUser(newUser);
        }
        if (loading === true) {
            setLoading(false);
        }
        console.log('user', storage.getUser());
    });

    const rowCounter = useRef(0);

    const handleSettings = () => {
        setDisplayOption(true);
        setOption('settings');
    };

    const handleHelp = () => {
        setDisplayOption(true);
        setOption('help');
    };

    const handleCloseOption = () => {
        setDisplayOption(false);
    };

    const handleStatistics = () => {
        setDisplayOption(true);
        setOption('statistics');
    };

    const addLetter = useCallback(
        (letter) => {
            setStatus(null);
            if (gameOver === false && word.length !== config.wordLength) {
                setWord(word + letter.toLowerCase());
            }
        },
        [word],
    );

    const validateWord = () => {
        if (gameOver === false) {
            setShowMessage(false);
            if (!wordlist.includes(word)) {
                // the word is not in the list
                setMessage('Not in the word list');
                setShowMessage(true);
                console.log('Not in the word list');
                // set time out.
                setTimeout(() => {
                    console.log('time out');
                    setShowMessage(false);
                }, 1000);
            } else if (word === FINDING_WORD) {
                // game over: win
                setLetters([
                    ...letters,
                    ...word.split('').map((letter) => ({ status: 'correct', letter })),
                ]);
                setWord('');
                console.log('You win!');
                setGameOver(true);
                setMessage('You win!');
                setShowMessage(true);
                rowCounter.current += 1;
                const updatedUser = storage.getUser();
                // update text statistics
                updatedUser.textStatistics.played += 1;
                updatedUser.textStatistics.win += 1;
                updatedUser.textStatistics.currentStreak += 1;
                if (updatedUser.textStatistics.currentStreak > updatedUser.textStatistics.maxStreak) {
                    updatedUser.textStatistics.maxStreak = updatedUser.textStatistics.currentStreak;
                }
                // update graph statistics
                if (rowCounter.current === 1) {
                    updatedUser.graphStatistics.one += 1;
                } else if (rowCounter.current === 2) {
                    updatedUser.graphStatistics.two += 1;
                } else if (rowCounter.current === 3) {
                    updatedUser.graphStatistics.three += 1;
                } else if (rowCounter.current === 4) {
                    updatedUser.graphStatistics.four += 1;
                } else if (rowCounter.current === 5) {
                    updatedUser.graphStatistics.five += 1;
                } else if (rowCounter.current === 6) {
                    updatedUser.graphStatistics.six += 1;
                }
                storage.saveUser(updatedUser);
            } else {
                setLetters([
                    ...letters,
                    ...word.split('').map((letter, idx) => {
                        if (FINDING_WORD[idx] === letter) {
                            console.log('letter is correctly placed ' + letter);
                            const newKeyboardLetters = keyboardLetters;
                            newKeyboardLetters.correct.push(letter);
                            setKeyboardLetters(newKeyboardLetters);
                            return { status: 'correct', letter };
                        }
                        if (
                            FINDING_WORD.indexOf(letter) >= 0
                            && word[FINDING_WORD.indexOf(letter)] !== letter
                        ) {
                            console.log('letter is mispplaced ' + letter);
                            const newKeyboardLetters = keyboardLetters;
                            newKeyboardLetters.misplaced.push(letter);
                            setKeyboardLetters(newKeyboardLetters);
                            return { status: 'misplaced', letter };
                        }
                        console.log('letter is wrong ' + letter);
                        const newKeyboardLetters = keyboardLetters;
                        newKeyboardLetters.wrong.push(letter);
                        setKeyboardLetters(newKeyboardLetters);
                        return { status: 'wrong', letter };
                    }),
                ]);
                setWord('');
                rowCounter.current += 1;
                const updatedUser = storage.getUser();
                if (rowCounter.current === 6) {
                    // game over: lose
                    console.log('Game over!');
                    setGameOver(true);
                    setMessage(FINDING_WORD);
                    setShowMessage(true);
                    // update text statistics
                    updatedUser.textStatistics.played += 1;
                    updatedUser.textStatistics.currentStreak = 0;
                }
                storage.saveUser(updatedUser);
            }
        }
    };

    if (loading === true) {
        return (
            <div>loading</div>
        );
    }

    return (
        <div className="app-container">
            <Header
                appName={config.appName}
                handleHelp={handleHelp}
                handleSettings={handleSettings}
                handleStatistics={handleStatistics}
            />
            <div className="game-container">
                <div className="board-container">
                    <Message message={message} showMessage={showMessage} />
                    <Grid
                        letters={[
                            ...letters,
                            ...word.split('').map((letter) => ({ status, letter })),
                        ]}
                    />
                    <Keyboard
                        keyboardLetters={keyboardLetters}
                        letters={letters}
                        onKeyPress={addLetter}
                        onBackspace={() => setWord(word.slice(0, -1))}
                        onEnter={validateWord}
                    />
                </div>
                <Option
                    display={displayOption ? 'flex' : 'none'}
                    option={option}
                    handleClose={handleCloseOption}
                    textStatistics={storage.getUser().textStatistics}
                    graphStatistics={storage.getUser().graphStatistics}
                />
            </div>
            <Footer
                productName={config.productName}
                productDetail={config.productDetail}
                sprint={config.sprint}
                developTeam={config.developTeam}
            />
        </div>
    );
}

export default Wordle;